import ApiService from '@/services/ApiService'
import { Card, MissedCard } from '@/models/Card'

export default class CardService {
  public static async getNext(category?: string): Promise<Card> {
    return ApiService.get<Card>(`cards/next`, { category })
  }

  public static async getMostMissed(category: string, limit = 10): Promise<MissedCard[]> {
    return ApiService.get<MissedCard[]>(`cards/most-missed`, { category, limit })
  }

  public static async respond(cardId: string, response: string, duration_ms: number): Promise<{ is_correct: boolean, response: string }> {
    return ApiService.post<{ is_correct: boolean, response: string }>(`cards/${cardId}/respond`, { response, duration_ms })
  }
}
